/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
/* eslint react/prop-types: 0 */
import React, { Children } from 'react';
var RenderDetail = function RenderDetail(_a) {
    var title = _a.title, children = _a.children;
    return children && Children.count(children) ? (React.createElement("section", { className: "nx-vulnerability-details__section" },
        React.createElement("header", null,
            React.createElement("h4", { className: "nx-vulnerability-details__section-label" }, title)),
        React.createElement("div", { className: "nx-vulnerability-details__section-content" }, children))) : null;
};
export default RenderDetail;
//# sourceMappingURL=RenderDetail.js.map